// extracted by mini-css-extract-plugin
export default {"link":"HL-z","disabled":"IL-z"};